// import { Component } from '@angular/core';
// import { FormBuilder, Validators } from '@angular/forms';
// import { MessageService } from 'primeng/api';
// import { SigninService } from 'src/app/services/signin.service';
// import { Router } from '@angular/router';

// @Component({
//   selector: 'app-recuperar-password',
//   templateUrl: './recuperar-password.component.html',
//   styleUrls: ['./recuperar-password.component.scss'],
//   private router: Router
//   providers: [MessageService]
// })
// export class RecuperarPasswordComponent {

//   usuarioValido = false;
//   usuarioGuardado = '';

//   form = this.fb.group({
//     usuario: [null, Validators.required],
//     password: [null]
//   });

//   constructor(
//     private fb: FormBuilder,
//     private signinService: SigninService,
//     private messageService: MessageService
//   ) {}

//   enviar() {
//     const usuario = this.form.value.usuario;

//     this.signinService.recuperarPassword(usuario!)
//       .subscribe({
//         next: (resp: any) => {

//           if (resp.success) {
//             this.usuarioValido = true;
//             this.usuarioGuardado = usuario!;

//             this.messageService.add({
//               severity: 'success',
//               summary: 'OK',
//               detail: 'Usuario válido, ahora ingresa nueva contraseña'
//             });

//           } else {
//             this.messageService.add({
//               severity: 'error',
//               summary: 'Error',
//               detail: resp.message
//             });
//           }
//         },
//         error: () => {
//           this.messageService.add({
//             severity: 'error',
//             summary: 'Error',
//             detail: 'Error en servidor'
//           });
//         }
//       });
//   }

//   cambiarPassword() {
//     const password = this.form.value.password;

//     this.signinService.resetPassword(this.usuarioGuardado, password!)
//       .subscribe({
//         next: (resp: any) => {
//           this.messageService.add({
//             severity: 'success',
//             summary: 'OK',
//             detail: 'Contraseña actualizada correctamente'
//           });

//           this.usuarioValido = false;
//           this.form.reset();
//         },
//         error: () => {
//           this.messageService.add({
//             severity: 'error',
//             summary: 'Error',
//             detail: 'No se pudo actualizar la contraseña'
//           });
//         }
//       });
//   }
// }
import { Component } from '@angular/core';
import { FormBuilder, Validators } from '@angular/forms';
import { MessageService } from 'primeng/api';
import { SigninService } from 'src/app/services/signin.service';
import { Router } from '@angular/router';

@Component({
  selector: 'app-recuperar-password',
  templateUrl: './recuperar-password.component.html',
  styleUrls: ['./recuperar-password.component.scss'],
  providers: [MessageService]
})
export class RecuperarPasswordComponent {

  usuarioValido = false;
  usuarioGuardado = '';

  form = this.fb.group({
    usuario: [null, Validators.required],
    password: [null]
  });

  constructor(
    private fb: FormBuilder,
    private signinService: SigninService,
    private messageService: MessageService,
    private router: Router   // ✅ AQUÍ va
  ) {}

  enviar() {
    const usuario = this.form.value.usuario;

    this.signinService.recuperarPassword(usuario!)
      .subscribe({
        next: (resp: any) => {

          if (resp.success) {
            this.usuarioValido = true;
            this.usuarioGuardado = usuario!;

            this.messageService.add({
              severity: 'success',
              summary: 'OK',
              detail: 'Usuario válido, ahora ingresa nueva contraseña'
            });

          } else {
            this.messageService.add({
              severity: 'error',
              summary: 'Error',
              detail: resp.message
            });
          }
        },
        error: () => {
          this.messageService.add({
            severity: 'error',
            summary: 'Error',
            detail: 'Error en servidor'
          });
        }
      });
  }

  cambiarPassword() {
    const password = this.form.value.password;

    this.signinService.resetPassword(this.usuarioGuardado, password!)
      .subscribe({
        next: (resp: any) => {
          this.messageService.add({
            severity: 'success',
            summary: 'OK',
            detail: 'Contraseña actualizada correctamente'
          });

          this.usuarioValido = false;
          this.form.reset();

          // ✅ Redirigir al login después de 1.5 segundos
          setTimeout(() => {
            this.router.navigate(['']);
          }, 1500);

        },
        error: () => {
          this.messageService.add({
            severity: 'error',
            summary: 'Error',
            detail: 'No se pudo actualizar la contraseña'
          });
        }
      });
  }
}